import { schemaCommon } from "common/bit/form/FormikSchema"
import * as yup from "yup"

const schemaSendEmail = yup
  .object({
    fullName: schemaCommon.fullName,
    email: schemaCommon.email,
    acceptTerms: yup.mixed().oneOf([true], "שדה חובה"),
  })
  .defined()

export const initialFormStatesSendWhatsapp: yup.InferType<
  typeof schemaSendEmail
> = {
  fullName: "",
  email: "",
  acceptTerms: false,
}

export default schemaSendEmail
